import React, { useEffect, useState } from 'react';
import { InfoCard } from '@backstage/core-components';
import Select from 'react-select';
import { useUser } from '../../context/userContext';
import Typography from '@mui/material/Typography';

export function DefaultGroupMembership() {
  const { getUser, updateUser } = useUser();
  const [value, setValue] = useState(undefined);
  const [userData, setUserData] = useState(null);

  const groupMemberships =
    userData !== null ? userData.user.groupMemberships : null;
  const defaultGroup =
    userData !== null
      ? groupMemberships.find(
          (group: {
            business_unit: string;
            squad: string;
            department: string;
            default: boolean;
          }) => group.default === true,
        )
      : null;

  const groupMembershipArray = () => {
    let groupArr;

    if (userData !== null) {
      groupArr = groupMemberships.map((group: { squad: string }) => {
        return { value: group.squad, label: group.squad };
      });
    } else {
      groupArr = [{ value: 'loading', label: 'loading' }];
    }

    return groupArr;
  };

  const updatedGroupMemberships = (selectedGroup: { value: string }) => {
    const arr = userData.user.groupMemberships.map(
      (x: {
        squad: string;
        business_unit: string;
        department: string;
        default: boolean;
      }) => {
        if (x.squad === selectedGroup.value) {
          return {
            squad: selectedGroup.value,
            business_unit: x.business_unit,
            department: x.department,
            default: true,
          };
        }

        return {
          squad: x.squad,
          business_unit: x.business_unit,
          department: x.department,
          default: false,
        };
      },
    );

    return arr;
  };

  useEffect(() => {
    if (defaultGroup !== undefined && userData !== null) {
      setValue(defaultGroup.squad);
    }
  }, [defaultGroup, userData]);

  useEffect(() => {
    (async () => {
      const user = await getUser();
      setUserData({
        user: user,
      });
    })();
  }, [getUser]);

  const customStyles = {
    menuList: (provided: any) => ({
      ...provided,
      height: '100%',
      color: '#08699B',
      paddingTop: '3px',
    }),
  };

  return (
    <InfoCard title="Change default group" variant="gridItem">
      {groupMembershipArray().length >= 2 ? (
        <>
          <Typography style={{ paddingBottom: '20px' }}>
            {value !== undefined
              ? `Your current defaulted group: ${value}. Changes are automatically saved after leaving this page.`
              : "You currently don't have a group defaulted in the portal"}
          </Typography>

          <div style={{ width: '50%' }}>
            <Select
              styles={customStyles}
              defaultValue={{
                label: 'Select from dropdown',
                value: 'Select from dropdown',
              }}
              options={groupMembershipArray()}
              onChange={selected => {
                updateUser({
                  email: userData.user.email,
                  username: userData.user.username,
                  group_memberships: updatedGroupMemberships(selected),
                });

                setValue(selected?.label);
              }}
            />
          </div>
        </>
      ) : (
        <Typography style={{ paddingBottom: '20px' }}>
          You don't currently have multiple group memberships inside the portal.
        </Typography>
      )}
    </InfoCard>
  );
}
